import ReactDom from "react-dom";
import "core/modale/ImportMissionModal.scss";
import Icon from "core/icon/Icon";
import InfoContext from "pages/InfoContext";
import InputSearchTag from "core/inputs/input-search/InputSearchTag";
import _ from "lodash";
import { useIntl } from "react-intl";
import { MissionBody } from "./MissionBody";
import {
  TAG_TYPES,
  FILTERS_FOR_NAMES,
  PROFILE_ID_DEFAULT,
  WORKER_TYPES,
} from "constants/constants";
import { formatReceivedData, getStringyfiedFilters } from "utils/missionHelper";
import { formatUsersOptions } from "components/form/CommonInputs";
import { useState, useEffect, useContext } from "react";
import {
  FORM_INFO,
  MISSION_FORM_LABELS,
  MISSION_FORM_PLACEHOLDERS,
} from "constants/forms";

const ImportMissionModal = ({ open, onClose }) => {
  const intl = useIntl();
  const [consultantInput, setConsultantInput] = useState([]);
  const [missionData, setMissionData] = useState();

  const {
    getNamesByFilters,
    namesByFilters,
    getMissionsByFilters,
    missionsByFilters,
    lang,
  } = useContext(InfoContext);

  useEffect(() => {
    const close = (e) => {
      if (e.target.className === "overlay-style") {
        onClose();
        setConsultantInput([]);
        setMissionData();
      }
    };
    document.addEventListener("click", close);
    return () => document.removeEventListener("click", close);
  }, [onClose]);

  useEffect(() => {
    if (consultantInput[0]?.value) {
      const filters = {
        workers_ids: [consultantInput[0]?.value],
      };
      getMissionsByFilters({
        page: 1,
        filters: getStringyfiedFilters(filters),
        userScope: null,
      });
    }
  }, [consultantInput]);

  useEffect(() => {
    if (consultantInput.length > 0 && missionsByFilters?.content?.length > 0) {
      // get all IDs necessary (clients, managers, staff, etc.)
      const allIds = _.chain(missionsByFilters.content)
        .map((item) => [
          item.client_id,
          item.manager_id,
          item.worker_id,
          item.adv_id,
          item.rate_coordinator,
          item.signed_by_id,
          item.charged_by_id,
        ])
        .flatten()
        .filter((id) => id)
        .uniqWith(_.isEqual)
        .value();

      if (allIds.length > 0) {
        getNamesByFilters({
          types: [FILTERS_FOR_NAMES.CLIENT, FILTERS_FOR_NAMES.PERSON],
          id: allIds,
          include_deleted: true,
        });
      }
    }
  }, [missionsByFilters]);

  useEffect(() => {
    if (consultantInput?.length > 0 && missionsByFilters?.content) {
      setMissionData(
        formatReceivedData({
          data: missionsByFilters.content,
          namesByFilters: namesByFilters,
          worker_id: consultantInput,
        })
      );
    }
  }, [missionsByFilters, namesByFilters]);

  const renderMissionBody = ({ data }) =>
    data?.map((elm) => (
      <MissionBody
        key={elm.id}
        data={elm}
        lang={lang}
        setMissionData={setMissionData}
      />
    )) || [];

  if (!open) return null;
  return ReactDom.createPortal(
    <div>
      <div className="overlay-style" />
      <div className="import-modal-style">
        <div className="header">
          <div className="title">
            {intl
              .formatMessage({
                id: "import_mission",
                defaultMessage: "Import information d’une mission EOS",
              })
              .toUpperCase()}
          </div>
          <Icon
            color="gray-200"
            icon="close"
            onClick={() => {
              onClose();
              setConsultantInput([]);
              setMissionData();
            }}
          />
        </div>
        <div>
          <div className="search">
            {
              <InputSearchTag
                getOptions={(search) =>
                  getNamesByFilters({
                    profile: [
                      WORKER_TYPES.CONSULTANT,
                      WORKER_TYPES.SUBCONTRACTOR,
                    ],
                    types: [FILTERS_FOR_NAMES.PERSON],
                    search,
                  })
                }
                label={MISSION_FORM_LABELS.worker_id}
                limitChoice={1}
                minLength={2}
                onDelete={() => {
                  setConsultantInput([]);
                  setMissionData();
                }}
                options={formatUsersOptions({
                  users: namesByFilters,
                  type: TAG_TYPES.CSLT_STR,
                })}
                placeholder={MISSION_FORM_PLACEHOLDERS.worker_id}
                popup={FORM_INFO.CSLT_STR.popup}
                selectedOptions={consultantInput}
                setValue={setConsultantInput}
                type={TAG_TYPES.CSLT_STR}
                id="consultant-input"
              />
            }
          </div>
          <div style={{ overflowY: "auto", maxHeight: "444px" }}>
            {missionData && renderMissionBody({ data: missionData })} <br />
          </div>
        </div>
        <br /> <br />
      </div>
    </div>,
    document.getElementById("portal")
  );
};

export default ImportMissionModal;
